// Mock data for Carboniq Technologies website

export const companyInfo = {
  name: "Carboniq Technologies",
  tagline: "Precision in Design. Value in Every Detail.",
  description: "End-to-end mechanical design services from concept to design-for-manufacture.",
  email: "info@carboniqtech.com",
  phone: "+1 (555) 123-4567",
  address: "123 Engineering Park, Tech District, Innovation City"
};

export const services = [
  {
    id: 1,
    title: "Concept Design",
    description: "From requirements study to 3D rendering, we bring your vision to life with comprehensive material selection, ergonomic analysis, and detailed sketching.",
    icon: "Lightbulb",
    features: ["Requirement Study", "Sketching & Ideation", "Material Selection", "Ergonomics Analysis", "3D Rendering"]
  },
  {
    id: 2,
    title: "3D Modeling & Drafting",
    description: "Precision 3D CAD modeling, assembly design, and manufacturing drawings with GD&T compliance for seamless production handoff.",
    icon: "Box",
    features: ["Parts & Assemblies", "Manufacturing Drawings", "GD&T Standards", "BOM Generation", "CAD Tool Expertise"]
  },
  {
    id: 3,
    title: "Design for Manufacture",
    description: "Optimize your designs for production efficiency with tolerance stack-up analysis, manufacturability reviews, and cost-effective solutions.",
    icon: "Settings",
    features: ["Design Optimization", "Tolerance Analysis", "DFM Reviews", "Cost Reduction", "Production Planning"]
  },
  {
    id: 4,
    title: "Reverse Engineering",
    description: "Recreate existing parts and assemblies through advanced 3D scanning, precise modeling, and comprehensive drawing recreation.",
    icon: "RotateCcw",
    features: ["3D Scanning", "Part Recreation", "Legacy System Updates", "Drawing Recreation", "Quality Verification"]
  },
  {
    id: 5,
    title: "Detailed Engineering",
    description: "Complete engineering documentation, analysis, and validation to ensure your designs meet all specifications and standards.",
    icon: "FileText",
    features: ["Engineering Analysis", "Documentation", "Standards Compliance", "Design Validation", "Technical Reports"]
  },
  {
    id: 6,
    title: "Sustenance Engineering",
    description: "Keep your legacy systems current with data migration, 2D to 3D conversion, and ongoing design updates and support.",
    icon: "RefreshCw",
    features: ["Legacy Updates", "Data Migration", "2D to 3D Conversion", "Design Modifications", "Ongoing Support"]
  }
];

export const industries = [
  {
    id: 1,
    name: "Heavy Equipment",
    description: "Design solutions for construction, mining, and agricultural machinery with focus on durability and performance."
  },
  {
    id: 2,
    name: "Industrial Machinery",
    description: "Comprehensive mechanical design for manufacturing equipment, automation systems, and production tools."
  },
  {
    id: 3,
    name: "Automotive Components",
    description: "Precision automotive parts design with emphasis on quality, efficiency, and manufacturing excellence."
  },
  {
    id: 4,
    name: "Consumer Products",
    description: "Innovative product design combining functionality, aesthetics, and manufacturability for consumer markets."
  },
  {
    id: 5,
    name: "Process Equipment",
    description: "Specialized design services for plant engineering, process systems, and industrial infrastructure."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Cost-Effective Solutions",
    description: "Deliver high-quality designs that optimize production costs without compromising on quality or performance.",
    icon: "DollarSign"
  },
  {
    id: 2,
    title: "Scalable Design Support",
    description: "From single projects to ongoing partnerships, we scale our services to match your engineering needs.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Multi-CAD Expertise",
    description: "Proficient across SolidWorks, Creo, Inventor, AutoCAD, and more - we work with your preferred tools.",
    icon: "Layers"
  },
  {
    id: 4,
    title: "Quick Turnaround",
    description: "Fast response times and on-schedule delivery to keep your projects moving forward without delays.",
    icon: "Clock"
  }
];

export const projects = [
  {
    id: 1,
    title: "Industrial Pump Assembly",
    industry: "Process Equipment",
    challenge: "Client needed a complete redesign of their centrifugal pump system to improve efficiency and reduce manufacturing costs.",
    solution: "Conducted full DFM analysis, optimized component geometry, reduced part count by 30%, and improved hydraulic efficiency by 15%.",
    outcome: "25% reduction in manufacturing costs, 15% efficiency improvement, and smoother assembly process."
  },
  {
    id: 2,
    title: "Automotive Bracket System",
    industry: "Automotive Components",
    challenge: "Legacy mounting bracket design required modernization with weight reduction while maintaining structural integrity.",
    solution: "Applied topology optimization, converted to 3D CAD from 2D drawings, performed FEA validation, and updated to latest GD&T standards.",
    outcome: "40% weight reduction, improved strength-to-weight ratio, and full compliance with automotive standards."
  },
  {
    id: 3,
    title: "Agricultural Equipment Retrofit",
    industry: "Heavy Equipment",
    challenge: "Modernize 20-year-old harvester component with no existing CAD data for spare parts manufacturing.",
    solution: "3D scanned existing parts, reverse engineered complete assembly, created manufacturing drawings, and established digital archive.",
    outcome: "Enabled ongoing spare parts production, reduced lead time by 60%, and created comprehensive digital documentation."
  }
];

export const team = [
  {
    id: 1,
    name: "Gokul",
    role: "Technical Director",
    bio: "Leading our engineering excellence with 15+ years of mechanical design expertise."
  },
  {
    id: 2,
    name: "Madhu",
    role: "Business Development Manager",
    bio: "Driving client relationships and ensuring seamless project delivery and satisfaction."
  }
];

export const navigationLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Industries", path: "/industries" },
  { name: "Projects", path: "/projects" },
  { name: "Contact", path: "/contact" }
];
